module.exports = __webpack_public_path__ + "img/default-question-current-insurer.31e42199.svg";